;(function ($) {
	"use strict";
	window.PositionController = function (options) {
		this._init(options);
	};

	$.extend(PositionController.prototype, {
		$options: {
			debug: false,
			loading: false,
			latChanged: false,
			lonChanged: false,
		},

		//=====================================================================

		checkLocation: function (forced) {
			var app = this,
				lang = $Lang.wrongDoings,
				$wrongDoingController = window.$wdEventCommon,
				$coordLabel = $('#coordinates-button-label');
			if ((app.$options.debug || ((typeof $mobileDetector !== 'undefined') && $mobileDetector.mobile())) && navigator.geolocation) {
				var $latInput = $('#lat'),
					$lonInput = $('#lon'),
					$coordButton = $('#coordinates-button'),
					$coordinatesFrom = $('#coordinatesFrom'),
					$coordinatesSource = $('#coordinates_source');
				
				if ( forced || ( ! $latInput.val() ) ) {

					$coordLabel.text(lang.loading).show();
					app.blockLatLonInputs(true);
					try {
						navigator.geolocation.getCurrentPosition(function (position) {

								//Set geolocation enabled flag
								if ($wrongDoingController) {
									$wrongDoingController.setSheriffDeviceInfo('geolocationEnabled', true);
								}

								if (position && ('coords' in position)) {
									if (app.$options.loading) {
										$latInput.val(position.coords.latitude).trigger('change');
										$lonInput.val(position.coords.longitude).trigger('change');
										app.$options.loading = false;

										//GPS position successfully loaded
										if ($wrongDoingController) {
											$wrongDoingController.setSheriffDeviceInfo('geolocationSuccess', true);
										}
									}

									var selectVal = $('#trailId').val();
									if (!selectVal) {
										app.fillClosestTrails();
									}

									$coordLabel.text("").hide();
									$coordButton.text(lang.reload);
									app.$options.loading = false;

									$coordinatesFrom.text($Lang.events.coordinatesType.device);
									$coordinatesSource.val(window.$Common.events.coordinatesSources.COORDINATES_DEVICE);
								} else {
									$coordLabel.text(lang.loadingFailed).show();
									$coordButton.text(lang.reload);
									app.$options.loading = false;
								}

								app.blockLatLonInputs(false);
							},
							function (err) {
								console.log(err);
								app.switchToManual(lang.loadingFailed);
							},
							{timeout: 10000, enableHighAccuracy: true, maximumAge: 0});
					} catch (e) {
						app.switchToManual(lang.loadingFailed);
					}
				}
				app.$options.loading = true;
				$coordButton.text(lang.loadingStop);
				$coordLabel.text(lang.loading).show();
			} else {
				app.switchToManual(lang.loadingForbidden);
			}
		},
		
		switchToManual: function (labelText) {
			var app = this,
				lang = $Lang.wrongDoings,
				$coordButton = $('#coordinates-button'),
				$coordLabel = $('#coordinates-button-label');
			
			app.blockLatLonInputs(false);
			if (labelText) {
				$coordLabel.text(labelText).show();
			} else {
				$coordLabel.text(labelText).hide();
			}
			$coordButton.text(lang.reload);
			
			//Check if this is a registry form
			var $trailSelectRadio = $('input.placeTypeRadio#typeTrail');
			if ($trailSelectRadio.length) {
				//Change the input after $registry is initialized
				window.setTimeout(function() {
					$trailSelectRadio.prop('checked', true).trigger('change');
				}, 100);
			}
			app.$options.loading = false;
		},
		
		checkAgain: function () {
			//Check if this is a registry form
			var $lastLonSelectRadio = $('input.placeTypeRadio#typeLatLon');
			if ($lastLonSelectRadio.length) {
				$lastLonSelectRadio.prop('checked', true).trigger('change');
			} else {
				this.checkLocation(false);
			}
		},
		
		blockLatLonInputs: function (block) {
			var $latInput = $('#lat'),
				$lonInput = $('#lon');
			
			if (block) {
				$latInput.attr('readonly', true);
				$lonInput.attr('readonly', true);
			} else {
				$latInput.removeAttr('readonly');
				$lonInput.removeAttr('readonly');
			}
		},

		coordinatesButtonClick: function () {
			var lang = $Lang.wrongDoings;
			if ($('#coordinates-button').text() === lang.loadingStop) {
				this.blockLatLonInputs(false);
			} else {
				this.checkLocation(true);
			}
		},

		loadSelectLatLon: function ($option) {
			var app = this,
				$latInput = $('#lat'),
				$lonInput = $('#lon'),
				$latSpan = $('#latSpan'),
				$lonSpan = $('#lonSpan'),
				$coordinatesFrom = $('#coordinatesFrom'),
				$coordinatesSource = $('#coordinates_source');

			var url = route('wrongDoings.getTrailLatLon', {'trail': $option.val()});

			app.blockLatLonInputs(true);
			
			$.ajax({
				url: url,
				dataType: 'json',
				method: 'post',
				success: function (r) {
					if ($coordinatesSource.val() === window.$Common.events.coordinatesSources.COORDINATES_STREET) {
						$latInput.val(r.lat);
						$lonInput.val(r.lon);
						$latSpan.text(r.lat).trigger('change');
						$lonSpan.text(r.lon).trigger('change');
						$coordinatesFrom.text($Lang.events.coordinatesType.street);
					}

					app.blockLatLonInputs(false);
				},
				error: function (e) {
					app.blockLatLonInputs(false);
				},
			});
		},

		fillClosestTrails: function () {

			/*var app = this,
				lat = $('#lat').val(),
				lon = $('#lon').val();
			
			if (lat && lon) 
			{
				$.ajax({
					url: route('wrongDoings.getClosestTrails'),
					dataType: 'json',
					data: {
						'lat' : lat,
						'lon' : lon,
					},
					method: 'post',
					success: function (r) {
						let $select = $('#trailId');
						//$select.select2("destroy");
						$select.find("option").each(function() {
							$(this).remove();
						});
						$select.data('preventSearch', true);
						
						let first = true;
						$.each(r, function (i, trail) {
							var $trailOption = new Option(trail.text, trail.id, false, first);
							$select.append($trailOption);
							first = false;
						});
						$select.trigger('change');
						//$select.select2();
						//window.$whisperers.initSelect($select, null);
					},
					error: function (e) {
						if (e.responseJSON && ('message' in e.responseJSON))
						{
							toastr.error(e.responseJSON.message);
						}
					},
				});
			}*/
		},
		
		checkLatLonBothChanged: function () {
			const app = this;

			if (app.$options.latChanged && app.$options.lonChanged)
			{
				app.fillClosestTrails();
				app.$options.latChanged = false;
				app.$options.lonChanged = false;
			}
		},	

		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('change', "#trailId", function () {
				app.loadSelectLatLon($(this).find('option:selected'));
			});

			// $document.on('click', '#coordinates-button', function (e) {
			// 	e.preventDefault();
			// 	app.coordinatesButtonClick();
			// });
			
			$document.on('change', '#lat', function () {
				app.$options.latChanged = true,
				app.checkLatLonBothChanged();
			});
			$document.on('change', '#lon', function () {
				app.$options.lonChanged = true,
				app.checkLatLonBothChanged();
			});
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});

			this.handleButtons();
			this.checkLocation(false);
		},
	});

})(jQuery);

